// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2NVwp","imageUploader":"EGiftCard_imageUploader__3mDsy"};